<div class="main-content">
	<div class="col-md-12">

		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="row tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">

			</div>
			<div class="row tp-box__side tp-box__front dashboard-cards-row" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
				<div class="dashboard-card-col dashboard-stat-col"
					[class.d-none]="viewingCard && viewingCard !== 'carts'"
					[ngClass]="viewingCard === 'carts' ? 'col-md-12' : 'col-md-3'">
					<app-customer-carts (viewData)="viewingData($event, 'carts')"></app-customer-carts>
				</div>
				<div class="dashboard-card-col dashboard-stat-col"
					[class.d-none]="viewingCard && viewingCard !== 'tophundred'"
					[ngClass]="viewingCard === 'tophundred' ? 'col-md-12' : 'col-md-3'">
					<app-top-hundred [dashboard]="true" (viewData)="viewingData($event, 'tophundred')"></app-top-hundred>
				</div>
				<div class="dashboard-card-col dashboard-stat-col"
					[class.d-none]="viewingCard && viewingCard !== 'topcustomers'"
					[ngClass]="viewingCard === 'topcustomers' ? 'col-md-12' : 'col-md-3'">
					<app-top-customers [limit]="100" (viewData)="viewingData($event, 'topcustomers')"></app-top-customers>
				</div>
				<div class="dashboard-card-col dashboard-stat-col"
					[class.d-none]="viewingCard && viewingCard !== 'newcustomers'"
					[ngClass]="viewingCard === 'newcustomers' ? 'col-md-12' : 'col-md-3'">
					<app-new-customers (viewData)="viewingData($event, 'newcustomers')"></app-new-customers>
				</div>
				<div class="col-md-12 dashboard-card-col">
					<app-customer-no-purchase (viewData)="viewingData($event, 'nopurchase')"></app-customer-no-purchase>
				</div>
				<div class="col-md-12">
					<app-dashboard-sales-this-last></app-dashboard-sales-this-last>
				</div>



				<div class="col-md-12">
					<app-brand-report [customer]="false" [pos]="true"></app-brand-report>
				</div>
				<app-dashboard-cat-line *ngIf="telegramAllowed"></app-dashboard-cat-line>
			</div>
		</div>
	</div>
</div>
